import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-page">
      {/* Header - Same as Home Page */}
<div className="header">
  <div className="header-content">
    <div className="logo">
      <a href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
        <img src="/logo.png" alt="Airgati" className="logo-image" />
      </a>
    </div>
    <div className="nav">
    {/*  <a href="/#how-it-works">How it Works</a> */}
      <a href="/#features">Features</a>
      <a href="/#pricing">Pricing</a>
    </div>
    <div className="header-actions">
      <a href="/" className="sign-in-btn" style={{ textDecoration: 'none' }}>
        Back to Home
      </a>
    </div>
  </div>
</div>

{/* Page Title Section */}
<div className="page-title-section">
  <h1>Privacy Policy</h1>
  <p className="last-updated">Last Updated: December 2024</p>
</div>

      <div className="privacy-content">
        
        <div className="intro">
          <p><strong>Welcome to Airgati.com</strong> ("Airgati", "we", "our", or "us").</p>
          <p>We are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit or use Airgati.com, including any associated mobile site, tools, AI-powered travel assistance, or services (collectively, the "Services").</p>
          <p>By accessing or using our Services, you acknowledge that you have read, understood, and agree to the practices described below.</p>
        </div>

        <section>
          <h2>1. INFORMATION WE COLLECT</h2>
          <p>We collect information in several ways to provide and improve our flight search and travel-related services.</p>
          
          <h3>1.1 Information You Provide Directly</h3>
          
          <h4>a. Account & Identity Information</h4>
          <p>If you create an account, sign in using Google, Yahoo, or other identity providers, or communicate with us, you may provide:</p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number (optional)</li>
            <li>Profile information from third-party logins</li>
            <li>Preferences (currency, language, airports, travel settings)</li>
          </ul>

          <h4>b. Travel Search Information</h4>
          <p>When you request flight information, we collect:</p>
          <ul>
            <li>Origin and destination</li>
            <li>Travel dates</li>
            <li>Passenger count</li>
            <li>Cabin class</li>
            <li>Price filters, stops, and other search preferences</li>
            <li>Any travel-related details provided through our AI assistant</li>
          </ul>

          <h4>c. Communication Information</h4>
          <p>This includes:</p>
          <ul>
            <li>Messages with our AI assistant</li>
            <li>Customer support interactions</li>
            <li>Feedback, surveys, or inquiries</li>
            <li>Data you enter in forms on our platform</li>
          </ul>

          <h3>1.2 Information We Collect Automatically</h3>
          
          <h4>a. Device & Usage Information</h4>
          <p>We automatically collect:</p>
          <ul>
            <li>IP address</li>
            <li>Browser type & version</li>
            <li>Operating system</li>
            <li>Referring/exit pages</li>
            <li>URLs clicked and pages viewed</li>
            <li>Session duration & timestamps</li>
            <li>Device identifiers</li>
            <li>Performance metrics</li>
          </ul>

          <h4>b. Cookies & Tracking Tools</h4>
          <p>We use cookies, web beacons, pixels, analytics scripts, session tracking, and AI analytics tools. These help us:</p>
          <ul>
            <li>Remember your preferences</li>
            <li>Auto-fill flight search inputs</li>
            <li>Improve personalization</li>
            <li>Detect fraud</li>
            <li>Improve site performance</li>
          </ul>
          <p>You can disable cookies in your browser settings but doing so may limit functionality.</p>

          <h3>1.3 Information from Third Parties</h3>
          <p>We may receive data from:</p>
          <ul>
            <li>Flight APIs (e.g., Amadeus)</li>
            <li>Affiliate partners</li>
            <li>Advertising networks</li>
            <li>Analytics platforms (e.g., Google Analytics)</li>
            <li>Identity providers (Google, Yahoo, etc.)</li>
          </ul>
          <p>This may include aggregated travel data, booking trends, or confirmation of completed transactions.</p>
        </section>

        <section>
          <h2>2. HOW WE USE YOUR INFORMATION</h2>
          <p>We use your information for the following lawful purposes:</p>

          <h3>2.1 To Provide Core Services</h3>
          <ul>
            <li>Deliver flight search results</li>
            <li>Show price comparisons</li>
            <li>Enable AI travel assistance</li>
            <li>Provide personalized travel recommendations</li>
          </ul>

          <h3>2.2 To Improve User Experience</h3>
          <ul>
            <li>Train our recommendation systems</li>
            <li>Enhance search accuracy</li>
            <li>Optimize site performance</li>
            <li>Improve AI response quality</li>
          </ul>

          <h3>2.3 To Communicate with You</h3>
          <ul>
            <li>Send service-related notifications</li>
            <li>Provide updates or promotional offers</li>
            <li>Respond to inquiries and support requests</li>
          </ul>

          <h3>2.4 For Security & Fraud Prevention</h3>
          <ul>
            <li>Detect suspicious activity</li>
            <li>Prevent unauthorized access</li>
            <li>Monitor for policy violations</li>
          </ul>

          <h3>2.5 Legal & Compliance Purposes</h3>
          <ul>
            <li>Maintain records</li>
            <li>Respond to legal requests</li>
            <li>Enforce Terms of Use</li>
          </ul>

          <p className="highlight">We do NOT sell personal information.</p>
        </section>

        <section>
          <h2>3. HOW WE SHARE YOUR INFORMATION</h2>
          <p>We may share information as follows:</p>

          <h3>3.1 Travel Providers & Partners</h3>
          <p>To complete your search or redirect you to booking partners, we may share:</p>
          <ul>
            <li>Flight search parameters</li>
            <li>Device or referrer information</li>
            <li>Aggregated analytics</li>
          </ul>
          <p>We DO NOT share your personal profile details unless necessary for the requested service.</p>

          <h3>3.2 Service Providers</h3>
          <p>We use trusted vendors for:</p>
          <ul>
            <li>Cloud hosting (e.g., Vercel, Supabase)</li>
            <li>AI processing (e.g., Claude API)</li>
            <li>Analytics</li>
            <li>Error tracking</li>
            <li>Customer support tools</li>
          </ul>
          <p>They are contractually required to keep your data confidential.</p>

          <h3>3.3 Legal Obligations</h3>
          <p>We may disclose information when required:</p>
          <ul>
            <li>By law or legal process</li>
            <li>To comply with government investigations</li>
            <li>To protect Airgati's rights, users, or property</li>
            <li>To investigate fraud or security issues</li>
          </ul>
        </section>

        <section>
          <h2>4. DATA RETENTION</h2>
          <p>We retain information only as long as necessary for:</p>
          <ul>
            <li>Service functionality</li>
            <li>Legal compliance</li>
            <li>Fraud prevention</li>
            <li>Business continuity</li>
          </ul>
          <p>You may request deletion of your data at any time (see Section 8).</p>
        </section>

        <section>
          <h2>5. SECURITY MEASURES</h2>
          <p>We use industry-standard safeguards to protect your data, including:</p>
          <ul>
            <li>Encryption (HTTPS, TLS)</li>
            <li>Secure APIs</li>
            <li>Access controls</li>
            <li>Anonymization of AI conversations where possible</li>
            <li>Regular security audits</li>
          </ul>
          <p><em>No system is 100% secure, and we cannot guarantee absolute protection.</em></p>
        </section>

        <section>
          <h2>6. CHILDREN'S PRIVACY</h2>
          <p>Airgati.com is not intended for users under the age of 16. We do not knowingly collect information from children. If data is collected inadvertently, we will delete it immediately.</p>
        </section>

        <section>
          <h2>7. INTERNATIONAL DATA TRANSFERS</h2>
          <p>Your information may be processed in the United States or in other countries where our providers operate. These may have different data protection laws than your jurisdiction. We use contractual safeguards to protect your data.</p>
        </section>

        <section>
          <h2>8. YOUR PRIVACY RIGHTS</h2>
          <p>Depending on your location, you may have the right to:</p>
          <ul>
            <li>Access your data</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion</li>
            <li>Opt-out of marketing communications</li>
            <li>Restrict processing</li>
            <li>Request data portability</li>
            <li>Opt-out of cookie tracking</li>
          </ul>
          <p>To exercise any rights, email: <a href="mailto:privacy@airgati.com">privacy@airgati.com</a></p>
          <p>We will respond within the legally required timeframe.</p>
        </section>

        <section>
          <h2>9. AI DATA USAGE</h2>
          <p>Airgati uses AI models to:</p>
          <ul>
            <li>Interpret travel queries</li>
            <li>Extract flight parameters</li>
            <li>Provide customer assistance</li>
            <li>Analyze usage trends</li>
          </ul>
          <p className="highlight">We do NOT use your personal data to train public AI models.</p>
          <p>Conversations may be stored in anonymized form for improvement of user experience.</p>
        </section>

        <section>
          <h2>10. THIRD-PARTY LINKS</h2>
          <p>Our website may contain links to:</p>
          <ul>
            <li>Travel agencies</li>
            <li>Flight booking partners</li>
            <li>Affiliate offers</li>
            <li>Rental car or hotel providers</li>
          </ul>
          <p>We are not responsible for the privacy policies or practices of third-party sites.</p>
        </section>

        <section>
          <h2>11. CHANGES TO THIS PRIVACY POLICY</h2>
          <p>We may update this Privacy Policy at any time. Changes will be posted with an updated "Last Updated" date. Continued use of the Services after updates constitutes acceptance.</p>
        </section>

        <section>
          <h2>12. CONTACT US</h2>
          <p>If you have questions or concerns about this Privacy Policy, please contact us:</p>
          <p>
            📧 Email: <a href="mailto:privacy@airgati.com">privacy@airgati.com</a><br />
            🌐 Website: <a href="https://www.airgati.com">www.airgati.com</a>
          </p>
        </section>

      </div>

      <div className="privacy-footer">
        <p>&copy; 2024 Airgati.com. All rights reserved.</p>
        <a href="/">Return to Home</a>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
